import React from 'react';
import {
    Layout, Menu, Breadcrumb, Icon,
  } from 'antd';
import { Route, Link } from "react-router-dom";

import HccCalCalculation from './HccCalCalculationChi';
import HccCalIntro from './HccCalIntroChi';
import LDEval from './LDevaluationChi';
import "../../assets/css/App.css";
import Background from "../../assets/images/BG1.jpg";
import Header1 from '../public';


const { SubMenu } = Menu;
const {
  Header, Content, Footer, Sider,
} = Layout;

var sectionStyle = {
  width: "100%",

// makesure here is String确保这里是一个字符串，以下是es6写法
  backgroundImage: `url(${Background})`,
  backgroundColor:'rgba(255,178,178,0.2)',
};

class HCCchi extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return(
            <div className="hcc"> 
            <Header1></Header1> 
            <Content style={{ padding: '0 50px' }}>

              <Layout style={{background: '#fff' }}>
              <Sider width={200} style={{ background: '#fff' }}>
                  <Menu
                    mode="inline"
                    defaultSelectedKeys={['0']}
                    defaultOpenKeys={['sub3']}
                    style={{ height: '100%' }}
                  >
                    <SubMenu key="sub3" title={<span><Icon type="user" />碘油沉积</span>}>
                      <Menu.Item key="1"><Link to="/hcc-ld-introduction-chi">功能介绍</Link></Menu.Item>
                      <Menu.Item key="2"><Link to="/hcc-ld-evaluation-chi">碘油分析</Link></Menu.Item>
                    </SubMenu>
                    <SubMenu key="sub4" title={<span><Icon type="user" />预后预测</span>}>
                      <Menu.Item key="5"><Link to="/hcc-cal-introduction-chi">功能介绍</Link></Menu.Item>
                      <Menu.Item key="6"><Link to="/hcc-cal-calculation-chi">预后分析</Link></Menu.Item>
                    </SubMenu>
                  </Menu>
                </Sider>
                <Content>
                <div style={{background: `url(${Background}) no-repeat top center`,height:300,width: "100%",backgroundSize: "cover",}}>
                <div style={{textAlign:"center",color:"#fff"}}>
                <br></br><br></br><br></br><br></br>
                <txt style={{fontSize:45,fontWeight:'bold',}}>通过临床实践扩展我们对癌症的认识</txt><br></br>
                  
                  </div>
                </div >
      
                
                
               

      
                  <div style={{paddingLeft:100,paddingRight:80}}>
                  <br></br>
                  <br></br>
                  <txt style={{fontSize:24}}>

                  <txt style={{fontWeight:'bold',}}>肝细胞癌预后分析模块</txt>围绕经导管动脉化疗栓塞（TACE）手术的临床疗效与预后分析而设计。 该模块为肝细胞癌患者提供个体化的术前与术后临床疗效评估预测。
                  <br></br><br></br>本模块两个主要功能为：<txt style={{fontWeight:'bold',}}> <Link to="/hcc-ld-evaluation-chi">TACE术后定量化碘油沉积评价</Link></txt> 和 <txt style={{fontWeight:'bold',}}><Link to="/hcc-cal-calculation-chi">首诊肝细胞癌患者的TACE疗效评估</Link>.</txt>
                  </txt>
                  </div>
                  
         
                  </Content>
                
              </Layout>
              </Content>
            </div>
        )
    }
}
export default HCCchi;